import { FunctionComponent } from 'react';
import { UltraTablePreset } from '../../types/presets.types';
import { Button } from '@headlessui/react';
import { cn } from '../../../../../utilities/cn';

interface PresetSelectionBtnProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  preset: UltraTablePreset;
  selected: boolean;
}

const PresetSelectionBtn: FunctionComponent<PresetSelectionBtnProps> = ({
  preset,
  selected,
  ...props
}) => {
  return (
    <Button
      aria-describedby={preset.name}
      key={preset.id}
      className={cn(
        'rounded-lg px-3 py-1.5 uppercase tracking-wide transition focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-1',
        selected
          ? 'bg-mainblue text-white shadow-md focus-within:ring-mainblue hover:bg-[#162a4a] active:bg-[#0f1d33]'
          : 'bg-gray-400 text-white shadow focus-within:ring-gray-500 hover:bg-gray-500 active:bg-gray-600',
        props.className, // Fix the overriding of the className prop
      )}
      value={preset.id}
      {...props}
    >
      {preset.name}
    </Button>
  );
};

export default PresetSelectionBtn;
